import React from 'react'

const FlexBox = ({children, className, style}) => {
  let FBClassName = 'flexbox' + (className ? ' ' + className : '')
  return (
    <div className={FBClassName} style={style || {}}>
      {children}
    </div>
  )
}

export default FlexBox



// WEBPACK FOOTER //
// ../src/commons/components/SegmentsPopupContent/FlexBox.js